import makeRequest from '../helpers/api/makeRequest';
import getUrlSearch from '@assets/helpers/getUrlSearch';

const BASE_URL = `https://${process.env.API_URL}`;
const route = '/client/api';

export default class ApiManager {
  getData = async (shopId, path = '', params = {}) => {
    const allParams = getUrlSearch({...params, s: shopId});
    const separator = path.includes('?') ? '&' : '?';
    try {
      return await makeRequest(BASE_URL + route + path + separator + allParams);
    } catch (e) {
      console.log('Error making request to API', e);
      return null;
    }
  };

  /**
   * @param {string} path - The path of the API
   * @param {Object} data - The data to send to the API
   * @param {Object} options - The options to send to the API
   * @returns {Promise<*>}
   */
  postData = async (path, data, options) => {
    try {
      return await makeRequest(BASE_URL + route + path, 'POST', data, options);
    } catch (e) {
      console.log(e);
      return {error: e.message};
    }
  };

  putData = async (path, data) => {
    try {
      return await makeRequest(BASE_URL + route + path, 'PUT', data);
    } catch (e) {
      console.log(e);
      return {error: e.message};
    }
  };

  isInvalidCache = expiredAt => {
    if (!expiredAt) {
      return true;
    }
    return new Date() > new Date(expiredAt);
  };

  getCacheData = cacheKey => {
    const data = localStorage.getItem(cacheKey);
    return data ? JSON.parse(data) : {};
  };

  cacheApiData = (data, cacheKey) => {
    const cacheData = {data};
    const date = new Date();
    date.setMinutes(date.getMinutes() + 10);
    cacheData.expiredAt = date;
    localStorage.setItem(cacheKey, JSON.stringify(cacheData));
  };
}
